// Import model
import { AddressFieldOptions } from '../models/AddressFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for AddressFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class AddressFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a AddressFieldOptions instance
   */
  static deserialize(json: string): AddressFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a AddressFieldOptions instance
   */
  static fromObject(obj: any): AddressFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to AddressFieldOptions');
    }


    const instance: AddressFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      _84A08Cd8: obj['_84a08cd8'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of AddressFieldOptions instances
   */
  static deserializeArray(json: string): AddressFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a AddressFieldOptions instance to a JSON string
   */
  static serialize(instance: AddressFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a AddressFieldOptions instance to a plain object
   */
  static toObject(instance: AddressFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_84a08cd8': instance._84A08Cd8,
    };
  }

  /**
   * Serializes an array of AddressFieldOptions instances to a JSON string
   */
  static serializeArray(instances: AddressFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
